import React, { useState } from "react";

const CustomFileUpload = ({ handleChange }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedName, setSelectedName] = useState("");

  const handleFileChange = (event) => {
    console.log(event);
    const file = event.target.files[0];
    setSelectedFile(file);
    setSelectedName(file.name);
    handleChange(event);
    // setSelFile(file);
  };

  return (
    <div className="d-flex justify-content-start align-items-center">
      <div
        style={{
          width: "300px",
          textAlign: "center",
          border: "3px dashed rgb(210, 227, 244)",
          borderRadius: "10px",
          padding: "10px",
          position: "relative",
          cursor: "pointer",
        }}
      >
        <img
          src={"/cloud-upload.svg"}
          width={"90px"}
          height={"90px"}
          style={{ objectFit: "contain" }}
          alt="upload"
        />
        <h4 className="fw-400" style={{fontFamily: "Inter", color: "#00000080"}}>Browse Files to upload</h4>
        {/* <p
          style={{
            fontSize: "0.87rem",
            marginTop: "10px",
            color: "#bbcada",
          }}
        >
          Maximun file size 10mb
        </p> */}
        <input
          style={{
            display: "block",
            height: "100%",
            width: "100%",
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            opacity: 0,
            cursor: "pointer",
          }}
          type="file"
          onChange={handleFileChange}
        />
        <p
          style={{
            fontSize: "0.87rem",
            marginTop: "10px",
            color: "#bbcada",
          }}
        >
          {selectedName && `Selected File: ${selectedName}`}
        </p>
      </div>
    </div>
  );
};

export default CustomFileUpload;
